import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listAdminContracts } from "@/services/admin.service";
import { fmtMoney, fmtDate, statusColor } from "@/lib/format";

const AdminContracts = () => {
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { (async () => { try { setContracts(await listAdminContracts()); } finally { setLoading(false); } })(); }, []);
  return (
    <div className="space-y-6" data-testid="admin-contracts-page">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold">Admin</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mt-1">All contracts</h1>
      </div>
      <div className="bg-card border border-border rounded-xl overflow-x-auto">
        {loading ? <div className="p-12 text-center text-muted-foreground">Loading…</div> : (
          <table className="w-full text-sm">
            <thead className="bg-secondary/40 text-muted-foreground text-xs uppercase tracking-widest">
              <tr>
                <th className="text-left px-6 py-3 font-semibold">Title</th>
                <th className="text-left px-6 py-3 font-semibold">Business</th>
                <th className="text-left px-6 py-3 font-semibold">Freelancer</th>
                <th className="text-right px-6 py-3 font-semibold">Total</th>
                <th className="text-left px-6 py-3 font-semibold">Status</th>
                <th className="text-left px-6 py-3 font-semibold">Created</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {contracts.map((c) => (
                <tr key={c.contract_id} className="hover:bg-secondary/30">
                  <td className="px-6 py-3"><Link to={`/contracts/${c.contract_id}`} className="font-medium hover:text-primary">{c.title}</Link></td>
                  <td className="px-6 py-3 text-muted-foreground">{c.business_name}</td>
                  <td className="px-6 py-3 text-muted-foreground">{c.freelancer_name || c.freelancer_email}</td>
                  <td className="px-6 py-3 text-right font-display font-semibold">{fmtMoney(c.total_amount, c.currency)}</td>
                  <td className="px-6 py-3"><span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold ${statusColor(c.status)}`}>{c.status}</span></td>
                  <td className="px-6 py-3 text-muted-foreground">{fmtDate(c.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminContracts;
